import React from 'react';
import i18n from 'i18n';
import { IField } from 'modules/core/types/common';
import {
  requiredValidator,
  validatePositiveNumber,
  validateNonNegativeNumber,
  validateMinRequiredValueForDropdown,
} from 'modules/core/validators';
import { PercentAdornment, HighlightedInput } from 'modules/core/components';

import { TermDropdown } from '../CustomDropdowns/TermDropdown';
import { SHOP_BY_CALLBACK_FIELD_NAMES } from './ShopByCallbackFieldNames.const';

export const SBC_TERM_FIELD: IField = {
  name: SHOP_BY_CALLBACK_FIELD_NAMES.TERM,
  component: TermDropdown,
  label: i18n.t('components.lender.shopByCallback.term.label'),
  isVerticalAlign: true,
  controlProps: {
    required: true,
    rules: requiredValidator,
    validate: validateMinRequiredValueForDropdown,
  },
};

export const SBC_APR_FIELD: IField = {
  name: SHOP_BY_CALLBACK_FIELD_NAMES.APR,
  component: HighlightedInput,
  label: i18n.t('components.lender.shopByCallback.apr.label'),
  isVerticalAlign: true,
  controlProps: {
    textStyle: 'bold',
    textPosition: 'start',
    endAdornment: <PercentAdornment />,
    decimalScale: 2,
    required: true,
    rules: requiredValidator,
    validate: validateNonNegativeNumber,
    placeholder: i18n.t('components.input.placeholders.decimal'),
    allowNegative: false,
  },
};

export const SBC_LTV_FIELD: IField = {
  name: SHOP_BY_CALLBACK_FIELD_NAMES.LTV,
  component: HighlightedInput,
  label: i18n.t('components.lender.shopByCallback.ltv.label'),
  isVerticalAlign: true,
  controlProps: {
    textStyle: 'bold',
    textPosition: 'start',
    endAdornment: <PercentAdornment />,
    decimalScale: 2,
    required: true,
    rules: requiredValidator,
    validate: validatePositiveNumber,
    placeholder: i18n.t('components.input.placeholders.decimal'),
    allowNegative: false,
  },
};

export const SHOP_BY_CALLBACK_FIELDS: IField[] = [SBC_TERM_FIELD, SBC_APR_FIELD, SBC_LTV_FIELD];

export const SBC_REHASH_CALCULATOR_FIELDS: IField[] = [...SHOP_BY_CALLBACK_FIELDS];
